var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bread-crumb pd-medium-horizontal" },
    [
      _c("a", { attrs: { href: "javascript:;" } }, [_vm._v("社商经营")]),
      _vm._v(" "),
      _c("a", { attrs: { href: "javascript:;" } }, [_vm._v("丁老板")]),
      _vm._v(" "),
      _vm._l(_vm.crumbList, function(item, index) {
        return item.link
          ? _c(
              "a",
              {
                key: index,
                attrs: { href: "javascript:;" },
                on: { click: _vm.clickEvent }
              },
              [_vm._v(_vm._s(item.name))]
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _vm._l(_vm.crumbList, function(item, index) {
        return !item.link
          ? _c("a", { key: index, attrs: { href: "javascript:;" } }, [
              _vm._v(_vm._s(item.name))
            ])
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }